// game/character.js
import { GS, LEFT, RIGHT, UP, DOWN, div } from './utility.js';

// Constantes para tipos de movimiento
export const STOP = 0;
export const MOVE = 1;
export const PROB_MOVE = 0.1;

export class Character {
    constructor(name, x, y, dir, movetype, message) {
        this.name = name;
        this.x = x;
        this.y = y;
        this.px = this.x * GS;
        this.py = this.y * GS;
        this.vx = 0;
        this.vy = 0;
        this.speed = 4;
        this.moving = false;
        this.direction = dir;
        this.movetype = movetype;
        this.animcycle = 12;
        this.frame = 0;
        this.message = message;

        // Inicializar imágenes
        Character.images = Character.images || {};
        const names = ["player", "cygaar", "minister", "soldier", "inspector", "phin", "abster", "guru", "analyzer", "rick", "rose"];
        
        for (let i = 0; i < names.length; i++) {
            if (!Character.images[names[i]]) {
                Character.images[names[i]] = new Image();
                
                if (names[i] === "phin") {
                    Character.images[names[i]].src = "/images/ruggchecker.png";
                } else if (names[i] === "abster") {
                    Character.images[names[i]].src = "/images/abster.png";
                } else if (names[i] === "cygaar") {
                    Character.images[names[i]].src = "/images/king.png";
                } else if (names[i] === "guru") {
                    Character.images[names[i]].src = "/images/guru.png";
                } else if (names[i] === "analyzer") {
                    Character.images[names[i]].src = "/images/analyzer.png";
                } else if (names[i] === "rick") {
                    Character.images[names[i]].src = "/images/rick.png";
                } else if (names[i] === "rose") {
                    Character.images[names[i]].src = "/images/rose.png";
                } else {
                    Character.images[names[i]].src = `/images/${names[i]}.png`;
                }
            }
        }
    }

    update(map) {
        this.frame += 1;

        if (this.moving) {
            this.px += this.vx;
            this.py += this.vy;
            if (this.px % GS === 0 && this.py % GS === 0) {
                this.moving = false;
                this.x = div(this.px, GS);
                this.y = div(this.py, GS);
            }
            return;
        }

        if (this.movetype === MOVE && Math.random() < PROB_MOVE) {
            this.direction = Math.floor(Math.random() * 4);
            this.moveStart(this.direction, map);
        }
    }

    draw(ctx, offset) {
        const no = div(this.frame, this.animcycle) % 4;
        ctx.drawImage(
            Character.images[this.name], 
            no * GS, 
            this.direction * GS, 
            GS, 
            GS,
            this.px - offset[0], 
            this.py - offset[1], 
            GS, 
            GS
        );
    }

    moveStart(dir, map) {
        this.direction = dir;
        let dx = 0, dy = 0;

        if (dir === LEFT) dx = -1;
        else if (dir === RIGHT) dx = 1;
        else if (dir === UP) dy = -1;
        else if (dir === DOWN) dy = 1;

        if (map.isMovable(this.x + dx, this.y + dy)) {
            this.vx = dx * this.speed;
            this.vy = dy * this.speed;
            this.moving = true;
        }
    }
}

// Subclase Player (no usada en tu proyecto actual, pero la incluyo por si la necesitas después)
export class Player extends Character {
    constructor(name, x, y, dir) {
        super(name, x, y, dir, STOP, "");
    }

    update(map) {
        this.frame += 1;

        if (this.moving) {
            this.px += this.vx;
            this.py += this.vy;
            if (this.px % GS === 0 && this.py % GS === 0) {
                this.moving = false;
                this.x = div(this.px, GS);
                this.y = div(this.py, GS);
            }
            return;
        }

        // activeKey definida en otro lugar
        if (window.activeKey === 37) {
            this.moveStart(LEFT, map);
        } else if (window.activeKey === 38) {
            this.moveStart(UP, map);
        } else if (window.activeKey === 39) {
            this.moveStart(RIGHT, map);
        } else if (window.activeKey === 40) {
            this.moveStart(DOWN, map);
        }
    }
}